var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M39.22 64.04H5.97L0 74.38h45.19z","key":0}),React.createElement("path",{"d":"M51.17 64.08l-26.1 45.22-3.75-6.51-5.97-10.34H1.66l5.97 10.34 9.03 15.64h16.82l31.38-54.35zM33.38 38.71h22.2l5.95-10.34H39.35L50.46 9.13l26.1 45.21h13.69L58.87 0H42.04L10.67 54.34h13.68zM94.86 64.04H75.54l-31.38 54.34h13.69L85.2 71.01l5 8.66 7.38 12.78H72.82l5.98 10.34h24.74l6.85-11.85-6.5-11.27z","key":1})]);
}

LogoInline.defaultProps = {"x":"0","y":"0","viewBox":"0 0 110.39 118.43"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
